module.exports = __webpack_public_path__ + "1.4.15-unryo/img/offline-analytic-1.cf98ceed.svg";